import { SectionHead } from "../SectionHead";
import { PatreonBlock } from "./PatreonBlock";
import { MerchBlock } from "./MerchBlock";

export const showPatreon = (s) => !!(s?.patreon_enabled && (s.patreon_url || s.patreon_tiers?.length));
export const showMerch = (s) => !!(s?.merch_enabled && (s.shop_url || s.merch_items?.length));
export const hasSupport = (s) => showPatreon(s) || showMerch(s);

export const Support = ({ index, site }) => (
  <section id="support" data-testid="support-section" className="relative px-5 sm:px-10 lg:px-16 py-16 md:py-24 border-t border-[#F5A524]/15 bg-[#0E0F14] overflow-hidden">
    <div aria-hidden="true" className="absolute -left-[3vw] bottom-0 font-display font-black uppercase text-[20vw] leading-none text-white/[0.03] select-none pointer-events-none">BACK</div>
    <SectionHead index={index} kicker="SUPPORT & SHOP" title={<>Back the<br /><span className="text-[#F5A524]">Emporio</span></>}>
      <p className="max-w-sm text-sm text-zinc-400">Every patron and every print keeps the ink flowing and the next issue coming.</p>
    </SectionHead>
    <div className="relative space-y-14 md:space-y-20">
      {showPatreon(site) && <PatreonBlock site={site} />}
      {showMerch(site) && <MerchBlock site={site} />}
    </div>
  </section>
);
